const Logo = () => {
    return (
        <a  href={"/"}>
            <span style={{ fontSize: 24, fontWeight: 500, color: "black" }}>EncryptedAssistant</span>
        </a>
    )
}

export {Logo}